<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    type?: "black" | "gray";
  }>(),
  {
    type: "gray",
  }
);
</script>
<template>
  <div
    class="p-2 gap-2 grid grid-cols-1 w-full rounded-md"
    :class="[
      { 'bg-black/60 backdrop-blur-sm': type === 'black' },
      { 'bg-neutral-800/80': type === 'gray' },
    ]"
  >
    <slot></slot>
  </div>
</template>

<style scoped lang="scss"></style>
